import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { HeroSlice } from './HeroSlice';
import { SpeakersSlice } from './SpeakersSlice';

import { WebinarLayout } from '@/layouts/WebinarLayout';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  webinar_hero_with_form: HeroSlice,
  speakers_section: SpeakersSlice,
};

export function CustomerEventPage(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
      </Head>
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
CustomerEventPage.Layout = WebinarLayout;
